import {observer} from 'mobx-react-lite'
import React from 'react'
import {useImportFromFileStore} from '../import-from-file-store'
import {FileSelected} from './file-selected'
import {SelectFile} from './select-file'

export const FileInput = observer(() => {
  const [state] = useImportFromFileStore()

  if (state.selectedFile) {
    return <FileSelected />
  }

  return <SelectFile />
})
